(function (Drupal, drupalSettings) {
  Drupal.behaviors.galerieSwiper = {
    attach: function (context, settings) {
      const galerieSwipers = context.querySelectorAll(".swiper-galerie");
      galerieSwipers.forEach((swiperElement) => {
        if (!swiperElement.dataset.galerieSwiperProcessed) {
          swiperElement.dataset.galerieSwiperProcessed = "true";

          new Swiper(swiperElement, {
            loop: true,
            navigation: {
              nextEl: swiperElement.querySelector(".swiper-button-next"),
              prevEl: swiperElement.querySelector(".swiper-button-prev"),
            },
            observer: true,
            observeParents: true,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
            },
          });
        }
      });
    },
  };
})(Drupal, drupalSettings);
